export default () => ({
  isCreatingMenu: false,
  isDeletingMenu: false,
  isGettingMenu: false,
  isUpdatingMenu: false,
  menu: {},
  rawMenu: {},
});
